import {
	AfterViewInit,
	Directive,
	ElementRef,
	HostBinding,
	Input,
	NgZone,
	OnDestroy,
	Renderer2,
} from '@angular/core';

@Directive({
	selector: '[appEllipsisTitle]',
})
export class EllipsisTitleDirective implements AfterViewInit, OnDestroy {
	@Input() public ellipsisTitle: '' | 'multiline' = '';
	@Input() public ellipsisLines = 2;
	@Input() public ellipsisTitleText?: string;

	@HostBinding('attr.title')
	public title: string | null = null;

	@HostBinding('style.overflow') public overflow = 'hidden';
	@HostBinding('style.text-overflow') public textOverflow = 'ellipsis';

	@HostBinding('style.display') public display = 'block';
	@HostBinding('style.white-space') public whiteSpace: string | null = 'nowrap';

	@HostBinding('style.-webkit-box-orient') public boxOrient: string | null =
		null;
	@HostBinding('style.-webkit-line-clamp') public lineClamp: string | null =
		null;
	@HostBinding('style.line-clamp') public lineClampStd: string | null = null;

	private resizeObserver?: ResizeObserver;

	public constructor(
		private readonly el: ElementRef<HTMLElement>,
		private readonly zone: NgZone,
		private readonly renderer: Renderer2
	) {}

	public ngAfterViewInit(): void {
		this.applyStyles();
		requestAnimationFrame(() => this.updateTitle());
		this.zone.runOutsideAngular(() => {
			this.resizeObserver = new ResizeObserver(() => {
				this.zone.run(() => this.updateTitle());
			});
			this.resizeObserver.observe(this.el.nativeElement);
		});
	}

	private get isMultiline(): boolean {
		return this.ellipsisTitle === 'multiline';
	}

	private applyStyles(): void {
		const el = this.el.nativeElement;
		if (this.isMultiline) {
			// const cs = getComputedStyle(el);
			// let lh = parseFloat(cs.lineHeight);
			// if (Number.isNaN(lh)) {
			// 	lh = parseFloat(cs.fontSize) * 1.75;
			// }
			// this.renderer.setStyle(el, 'max-height', `${lh * this.ellipsisLines}px`);
			this.renderer.setStyle(el, 'display', '-webkit-box');
			this.renderer.setStyle(el, 'overflow', 'hidden');
			this.renderer.setStyle(el, '-webkit-box-orient', 'vertical');
			this.renderer.setStyle(
				el,
				'-webkit-line-clamp',
				String(this.ellipsisLines)
			);
			this.renderer.setStyle(el, 'line-clamp', String(this.ellipsisLines));
			this.renderer.removeStyle(el, 'white-space');
		} else {
			this.renderer.setStyle(el, 'display', 'block');
			this.renderer.setStyle(el, 'overflow', 'hidden');
			this.renderer.setStyle(el, 'text-overflow', 'ellipsis');
			this.renderer.setStyle(el, 'white-space', 'nowrap');
			this.renderer.removeStyle(el, '-webkit-box-orient');
			this.renderer.removeStyle(el, '-webkit-line-clamp');
			this.renderer.removeStyle(el, 'line-clamp');
		}
	}

	private updateTitle(): void {
		const el = this.el.nativeElement;
		const truncated = this.isMultiline
			? el.scrollHeight > el.clientHeight
			: el.scrollWidth > el.clientWidth;
		const value = truncated
			? this.ellipsisTitleText ?? el.textContent?.trim() ?? null
			: null;
		if (value) {
			this.renderer.setAttribute(el, 'title', value);
		} else {
			this.renderer.removeAttribute(el, 'title');
		}
	}

	public ngOnDestroy(): void {
		this.resizeObserver?.disconnect();
	}
}
